import { FC } from "react";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import ShareIcon from "@mui/icons-material/Share";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { Tooltip } from "@mui/material";
import { NavigateFunction } from "react-router-dom";
import { formatCapacity } from "../../../UserLocationsFetchingColumns";

type ThirdMenuLocationDetailsParams = {
  t: (arg0: string) => string;
  navigate: NavigateFunction;
  locationSelectedDetails: any;
  totalUsersInlocation: number;
  sharedLocation: number;
  capacity: number;
  locationInfoFromTable:
    | {
        name: string;
        id: string;
        address: string;
        capacity: number;
        longitude: number;
        latitude: number;
        capacityDisplay?: {
          value: number;
          unit: {
            unitSymbolTextId: {
              text: string;
            };
            unitDescriptionTextId: {
              text: string;
            };
          };
        };
      }
    | undefined;
};

const ThirdMenuLocationDetails: FC<ThirdMenuLocationDetailsParams> = ({
  t,
  navigate,
  locationSelectedDetails,
  totalUsersInlocation,
  sharedLocation,
  capacity,
  locationInfoFromTable,
}) => {
  return (
    <div className="site-third-info-details">
      {/*loc */}
      <div className="location-detail-sec-third address-loc-det">
        <LocationOnIcon sx={{ marginRight: "3px" }} />
        <div>
          {locationSelectedDetails.address ?? locationInfoFromTable?.address}{" "}
          <br />
          {`Lat: ${locationSelectedDetails.latitude ?? locationInfoFromTable?.latitude} , Long: ${locationSelectedDetails.longitude ?? locationInfoFromTable?.longitude}`}
        </div>
      </div>
      {/* users */}
      {totalUsersInlocation >= 1 ? (
        <div className="location-detail-sec-third ml-3 address-loc-det">
          <PersonIcon />
          <div
            className="ml-1 users-div-detail-loc inline-loc-details"
            role="none"
            onClick={() => navigate("/users")}
          >{`${totalUsersInlocation} ${t(
            "Gran_tracker_bins.users-text",
          )}`}</div>
        </div>
      ) : (
        ""
      )}
      {/* share */}
      {sharedLocation >= 1 ? (
        <div className="location-detail-sec-third">
          <ShareIcon sx={{ marginRight: "2px" }} />
          <div
            className="inline-loc-details share-det-loc"
            role="none"
            onClick={() => console.log("share")}
          >{`${totalUsersInlocation} ${t(
            "Gran_tracker_bins.shared-access-text",
          )}`}</div>
        </div>
      ) : (
        ""
      )}
      {/* capacity */}
      {capacity >= 1 || (locationInfoFromTable?.capacity ?? 0) >= 1 ? (
        <div className="location-detail-sec-third">
          <WarehouseIcon sx={{ marginRight: "2px" }} />
          <div className="share-det-loc">
            {`${t("Gran_tracker_bins.capacity-text")} : ${capacity >= 1 ? formatCapacity(capacity) : `${formatCapacity(locationInfoFromTable?.capacityDisplay?.value ?? 0)}`} ${
              locationSelectedDetails?.totalCapacity?.unit?.unitSymbolTextId
                ?.text ??
              locationInfoFromTable?.capacityDisplay?.unit.unitSymbolTextId
                .text ??
              "T"
            }`}{" "}
            <Tooltip
              title={
                locationSelectedDetails?.totalCapacity?.unit
                  ?.unitDescriptionTextId.text ??
                locationInfoFromTable?.capacityDisplay?.unit
                  .unitDescriptionTextId.text ??
                ""
              }
            >
              <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
            </Tooltip>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ThirdMenuLocationDetails;
